export default __webpack_public_path__ + "images/73aac1a7011106284d691a713062e35a-tour.jpg";